import React from 'react'
import './style.css'

function ImportFornecedoresInfoStep2() {
  return (
    <div className='ImportFornecedoresInfoStep2'>
        <p>Você está na primeira etapa do assistente de importação. </p>

        <p>Vamos te orientar no Importação dos <b>FORNECEDORES</b>.</p>

        <p><b>Atenção:</b> Caracteres estranhos nas descrição do fornecedor serão removidos.</p>

        <p>Nesta tela você deve indicar o arquivo .CSV que contem as categorias relacionadas aos seus produtos.</p>
    </div>
  )
}

export default ImportFornecedoresInfoStep2;